import { useState } from 'react';
import { Link } from 'react-router-dom';
import { mangaList, categoryLabels } from '@/mocks/manga';

export default function RecommendList() {
  const [activeTab, setActiveTab] = useState<string>('all');

  const tabs = [
    { key: 'all', label: '全部推荐' },
    { key: 'kr', label: '韩漫' },
    { key: 'jp', label: '日漫' },
    { key: 'cn', label: '国漫' },
  ];

  const filtered = activeTab === 'all'
    ? mangaList
    : mangaList.filter((m) => m.category === activeTab);

  return (
    <section className="max-w-[1440px] mx-auto px-4 md:px-6 py-12 bg-background-100/60" aria-labelledby="recommend-title">
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-8 gap-4">
        <h2 id="recommend-title" className="font-heading text-2xl font-bold text-foreground-900">
          编辑推荐
        </h2>
        <div className="flex items-center bg-background-200/60 rounded-full px-1 py-1" role="tablist">
          {tabs.map((tab) => (
            <button
              key={tab.key}
              role="tab"
              aria-selected={activeTab === tab.key}
              onClick={() => setActiveTab(tab.key)}
              className={`whitespace-nowrap px-4 py-1.5 rounded-full text-sm font-medium transition-colors cursor-pointer ${
                activeTab === tab.key
                  ? 'bg-background-50 text-foreground-900'
                  : 'text-foreground-600 hover:text-foreground-800'
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-4 md:gap-5">
        {filtered.map((manga) => (
          <Link
            key={manga.id}
            to={`/article/${manga.id}`}
            className="group cursor-pointer"
          >
            <div className="relative aspect-[3/4] rounded-lg overflow-hidden mb-3">
              <img
                src={manga.cover}
                alt={manga.title}
                title={`${manga.title} - 星星动漫网`}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
              />
              <div className="absolute top-2 right-2">
                <span className="px-2 py-0.5 rounded text-xs font-medium bg-background-50/90 text-foreground-700">
                  {categoryLabels[manga.category]}
                </span>
              </div>
              {manga.status === '已完结' && (
                <div className="absolute top-2 left-2">
                  <span className="px-2 py-0.5 rounded text-xs font-medium bg-accent-500/90 text-white">
                    完结
                  </span>
                </div>
              )}
            </div>
            <h3 className="font-heading text-sm font-semibold text-foreground-900 line-clamp-1 group-hover:text-primary-600 transition-colors">
              {manga.title}
            </h3>
            <p className="text-xs text-foreground-500 mt-1">
              {manga.chapters.length}话 · 更新至{manga.updatedAt}
            </p>
          </Link>
        ))}
      </div>
    </section>
  );
}